import { Component, OnInit } from '@angular/core';
import { ToursService } from 'src/app/_services/tours.service';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-dashboard-tours',
  templateUrl: './dashboard-tours.component.html',
  styleUrls: ['./dashboard-tours.component.css']
})
export class DashboardToursComponent implements OnInit {

  destino: string = '';
  fecha:string = '';
  ordenarPor='destino';
  cantidadTours:number=0;
  imagenDefault = '../assets/images/body/tours/01.jpg';
  listTours: any [] = [];
  constructor(private tourService: ToursService) { }

  ngOnInit(): void {
    localStorage.removeItem("reservation");
    this.getToursByAgent(this.destino,this.fecha,this.ordenarPor);   
  }

  getToursByAgent(destino, fecha, ordenarPor) {
    this.tourService.getAllToursByAgent(destino, fecha, ordenarPor)
    .subscribe(data => {
      this.listTours= data.list;      
      this.cantidadTours = this.listTours.length;
    });
  }
  filterByElement(value){
    console.log(value);
  }

}
